<template>
    <el-drawer :modal="false" 
        :visible.sync="drawerViewHubTeamDetails"
        class="drawer-hub-team-details"
        size="45%"
    >
        <div slot="title" class="d-flex align-items-center" @click="modals.show_edit_hub = true" style="cursor: pointer" v-if="teamGroupData">
            <span>{{ teamGroupData.group_name }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="ml-2 text-primary"><path fill="currentColor" d="m19.3 8.925-4.25-4.2 1.4-1.4q.575-.575 1.413-.575t1.412.575l1.4 1.4q.575.575.6 1.388t-.55 1.387L19.3 8.925ZM17.85 10.4 7.25 21H3v-4.25l10.6-10.6 4.25 4.25Z"/></svg>
        </div>
        <b-container>
            <b-link @click="addTeam" :disabled="teamCount === 5">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6h-2Z"/></svg>
                    Add Team
            </b-link>
            
            <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form role="form" v-for="(team, index) in teams" :key="index">
                    <b-row class="mt-4">
                        <b-col cols="12">
                            <b-form-group>
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'teamName'"
                                >
                                    <div slot="label">
                                        Team Name
                                        <b-link class="text-danger float-right" @click="deleteTeam(team, index)">Delete</b-link>
                                    </div>
                                    <b-form-input
                                    v-model="team.team_name"
                                    placeholder="Enter Team Name"
                                    required
                                    ></b-form-input>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label="Team Type">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'teamType'"
                                >
                                    <!-- to show the selected team leader as well, use selectedteamleader function -->
                                    <el-select v-model="team.team_type" filterable placeholder="Select Team Type">
                                        <el-option
                                            v-for="option in options"
                                            :key="option.value"
                                            :label="option.label"
                                            :value="option.value"
                                        ></el-option>
                                    </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group> 
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label="Team Leader">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'teamLeader'"
                                >
                                    <!-- to show the selected team leader as well, use selectedteamleader function -->
                                    <el-select v-model="team.team_owner_id" filterable placeholder="Select Team Leader">
                                        <el-option
                                            v-for="option in userList"
                                            :key="index + '-' + option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        ></el-option>
                                    </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group> 
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label="Assistant Leader">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :vid="'teamAssistantLeader'"
                                >
                                    <!-- to show the selected team leader as well, use selectedteamleader function -->
                                    <el-select v-model="team.team_sub_owner_id" filterable placeholder="Select Team Assistant Leader">
                                    <el-option :key="null" :label="'---Select---'" :value="null"></el-option>
                                        <el-option
                                            v-for="option in userList"
                                            :key="index + '-' + option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        ></el-option>
                                    </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group> 
                        </b-col>
                        <b-col cols="12" v-if="!_gHlp.isEmpty(userList)">
                            <b-form-group label="Team Members">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'teamMembers'"
                                >
                                    <!-- change v-model to only show team_member_ids only 
                                    addded new team_member_ids in resource api
                                    -->
                                    <el-select
                                        v-model="team.team_member_ids"
                                        multiple
                                        filterable
                                        placeholder="Please enter a keyword">
                                        <el-option v-for="option in userList"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id">
                                            <div class="flex items-center">
                                                <span style="color: red " v-if="option.status > 1">{{ option.name }}</span>
                                                <span v-else>{{ option.name }}</span>
                                            </div>
                                        </el-option>
                                    </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="ml-auto text-right">
                            <!-- <b-button type="button" class="w-25" variant="primary" @click="updateHubTeams(team.hub_team_id, index)"  :disabled="invalid">Save</b-button> -->
                        </b-col>
                    </b-row>
                </b-form>
                <b-col cols="12" class="ml-auto text-right">
                    <b-button type="button" class="w-25" variant="primary" @click="updateHubTeams()"  :disabled="invalid">Save</b-button>
                </b-col>
            </ValidationObserver>
        </b-container>

        <EditHubDetailsModal :show_edit_hub.sync="modals.show_edit_hub"/>
    </el-drawer>
</template>
<script>
import { Drawer, Option, Select, Tag } from 'element-ui'
import EditHubDetailsModal from '@/views/Hub/HubDetails/EditHubDetailsModal'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { axios, services, getHeader, swal } from '@/assets/js/httpImports.js'
import { mapState } from 'pinia'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js';
import { useAccessControlStore } from '@/stores/accessControlStore'
import mainEventBus from '@/assets/js/mainEventBus.js'

export default {
    props: ['teamGroupData'],
    mixins: [notifyFunctionMixin],
    components: {
        EditHubDetailsModal,
        ValidationObserver,
        ValidationProvider,
        [Drawer.name]: Drawer,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tag.name]: Tag,
    },
    data() {
        return {
            drawerViewHubTeamDetails: false,
            modals:{
                show_edit_hub: false
            },
            options: [
				{
					value: 'PERMANENT_STAFF',
					label: 'Permanent Staff'
				},
				{
					value: 'MOBILE_TEAM',
					label: 'Mobile Team'
				}
			],
            teams: [],
            teamCount: 1,
            defaultTeamLeader: 28,
            selectTeamLeaderOptions: [],
            selectTeamMemberOptions: [],
            selectedTeamLeaderOptions: [],
            selectedTeamMemberOptions: []
        }
    },
    async created() {
        this.$watch(
            'teamGroupData',
            (newVal, oldVal) => {
                if (newVal) {
										this.teams = newVal.teams
										this.teams.forEach(itm => {
											itm['team_member_ids'] = !_gHlp.isEmpty(itm.team_members) ? itm.team_members.map(x => x.user_id) : []
										})
                    delete this.teams.team_member_ids
                    this.teamCount = newVal.teams.length
                }
            }
        );

    },
    computed: {
        ...mapState(useAccessControlStore, ['userList', 'teamManagerUserList', 'userListByAppCode']),
    },
    methods: {
        async viewHubTeamDetails() {
            this.drawerViewHubTeamDetails = !this.drawerViewHubTeamDetails;
        },
        createTeam(data) {
            axios.post(services.commission + 'team', data ,{ headers: getHeader() })
            .then ( response => {
                if (response.status === 200)
                {                      
                    console.log('res', response.data.data)
                    this.teams.push(response.data.data)  
                    // this.$notify({
                    //     message:
                    //     '<b>New Hub Sale Team </b> - Successfully Created.',
                    //     timeout: 10000,
                    //     icon: 'ni ni-bell-55',
                    //     type: 'default',
                    // });
                }
            })
            .catch ( error => {
                this.errorFunction(error, "Create Hub Sale Team Failed")
            })
        },
        addTeam() {
            if (this.teamCount < 5) {
                this.teamCount++
                const postData = {
                    team_group_id: this.teamGroupData.team_group_id,
                    team_type: 'PERMANENT_STAFF',
                    team_name: 'Team ' + this.teamGroupData.group_owner.name + ' ' + (this.teamGroupData.teams.length + 1)
                }
                const resp = this.createTeam(postData);
                mainEventBus.$emit('refresh-hub-listing')
            }
        },
        deleteTeam(hub_team, index) {
            swal.fire({
                title: 'Are you sure?',
                text: 'You will delete Sale Team - ' + hub_team.team_name,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    axios.delete(services.commission + 'team/' + hub_team.team_id,{ headers: getHeader() })
                    .then ( response => {
                        if (response.status === 200)
                        {
                            this.$notify({
                                message:
                                    '<b>Hub Sale Team : ' + hub_team.team_name + '</b> - Successfully Deleted.',
                                timeout: 10000,
                                icon: 'ni ni-bell-55',
                                type: 'default',
                            });

                            if (this.teamCount > 0) {
                                this.teams.splice(index, 1)
                                this.teamCount--
                            }
                            mainEventBus.$emit('refresh-hub-listing')
                        }
                    })
                    .catch ( error => {
                        this.errorFunction(error, "Delete Hub Team")
                    });
                } 
            })
        },
        updateHubTeams() {
            const promises = this.teams.map((item, index) => {
                return new Promise((resolve, reject) => {
                    let postData = {
                        team_type: item.team_type,
                        team_name: item.team_name,
                        team_owner_id: item.team_owner_id,
                        team_sub_owner_id: item.team_sub_owner_id,
                    };
    
                    axios.put(services.commission + 'team/' + item.team_id, postData ,{ headers: getHeader() })
                    .then (response =>  {
                        if (response.status === 200)
                        {
                            this.$notify({
                                message:
                                '<b>Hub Sale Team - ' + response.data.data.team_owner.name + ' </b> - Successfully Updated.',
                                timeout: 3000,
                                icon: 'ni ni-bell-55',
                                type: 'default',
                            });
                            // if success updated hub team, then only update hub team members
                            // this.createHubTeamMemberData(item.hub_team_id, index);
                            this.updateTeamMembers(item, index)
                            resolve();
                        }
                    })
                    .catch ( error => {
                        this.errorFunction(error, "Update Hub Sale Team Failed")
                        reject(error)
                    });
                })
            })

            Promise.all(promises)
            .then(() => {
                // All promises have resolved
                mainEventBus.$emit('refresh-hub-listing');
                this.drawerViewHubTeamDetails = false;
            })
            .catch(error => {
                // Handle errors if any of the promises fail
                this.errorFunction(error, 'Error updating hub teams');
            });
        },
        updateTeamMembers(team, index) {
            const postData = {
                team_id: team.team_id,
                user_ids: team.team_member_ids,
            }
            axios.post(services.commission + 'team/batch-members', postData ,{ headers: getHeader() })
            .then ( response =>  {
            })
            .catch ( error => {
                this.errorFunction(error, "Update Hub Sale Team Member Failed")
            });
        }
    }
}
</script>